import { Fragment } from 'react';
import type { ReactNode } from 'react';
import { highlightPlainText } from '@/utils/highlightSearchTerms';
import { plainTextHasUrl, splitPlainTextByUrls } from '@/utils/plainTextUrlSegments';

export const PLAIN_TEXT_LINK_CLASS = 'plain-text-link';

export type LinkifyPlainTextOptions = {
  highlightWords?: readonly string[];
  highlightClassName?: string;
  linkClassName?: string;
};

/** Безопасный React-рендер plain-text с кликабельными URL (без HTML-injection). */
export function linkifyPlainText(
  text: string | null | undefined,
  options?: LinkifyPlainTextOptions,
): ReactNode {
  if (text == null || text === '') return text ?? '';

  const highlightWords = options?.highlightWords?.filter(Boolean) ?? [];
  const hasHighlight = highlightWords.length > 0;
  const hasLinks = plainTextHasUrl(text);

  if (!hasLinks && !hasHighlight) return text;

  const segments = splitPlainTextByUrls(text);
  const parts: ReactNode[] = [];
  let key = 0;

  for (const segment of segments) {
    if (segment.type === 'text') {
      const content = hasHighlight
        ? highlightPlainText(segment.value, highlightWords, options?.highlightClassName)
        : segment.value;
      parts.push(<Fragment key={`t-${key++}`}>{content}</Fragment>);
      continue;
    }

    parts.push(
      <a
        key={`l-${key++}`}
        href={segment.href}
        target="_blank"
        rel="noreferrer noopener"
        className={options?.linkClassName ?? PLAIN_TEXT_LINK_CLASS}
      >
        {segment.value}
      </a>,
    );
  }

  return <Fragment>{parts}</Fragment>;
}
